import { render } from "./VisitorPreApprovedListTable.vue?vue&type=template&id=46bbe568"
import script from "./VisitorPreApprovedListTable.vue?vue&type=script&lang=js"
export * from "./VisitorPreApprovedListTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__